import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { AssetRepresentation } from '../../../../model/asset-representation';
import { TenantsService } from '../../../../services/tenants.service';

@Component({
  selector: 'app-tenant-asset-representations',
  templateUrl: './tenant-asset-representations.component.html',
  styleUrls: ['./tenant-asset-representations.component.scss']
})
export class TenantAssetRepresentationsComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public assetRepresentations: AssetRepresentation[];
  public totalAssetRepresentations: number;
  public loadingAssetRepresentations: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadAssetRepresentations(this.first / this.rows, this.rows);
  }

  private loadAssetRepresentations(offset: number, limit: number): void {
    this.loadingAssetRepresentations = true;
    this.tenantsService.getTenantAssetRepresentations(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.assetRepresentations = response.assetRepresentations.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalAssetRepresentations = response.totalElements;
        this.loadingAssetRepresentations = false;
      });
  }

  onPageChange(event): void {
    this.loadAssetRepresentations(event.first / event.rows, event.rows);
  }

}
